import { useEffect, useState } from 'react';
import { Modal, Col, Row, Form, Input, message, Spin, Button } from 'antd';
import { format } from 'rut.js';
import { createUser, getUser, updateUser } from '../../../services/general';
import { getCookie } from '../../../services/cookies';
import { DocumentCard, PhoneInput } from 'cmt-ui-kit';
import { handlers } from './../../../helpers/helpers';
import { useTranslation } from 'react-i18next';

const ApplicantModal = ({
  applicantModal,
  setApplicantModal,
  addApplicant,
  reservationForm
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState({ submit: false, fetch: false });
  const { t } = useTranslation();
  const countryCode = getCookie('country_code')
  const [documentType, setDocumentType] = useState(countryCode === 'CL' ? 'rut' : 'dni');

  const closeModal = () => {
    form.resetFields();
    setApplicantModal({ ...applicantModal, visible: false })
  };

  const validateFormFields = () => {
    if (
      (form.getFieldValue('firstName') !== '' && form.getFieldValue('firstName') !== null)
      && (form.getFieldValue('lastName') !== '' && form.getFieldValue('lastName') !== null)
      && (form.getFieldValue('email') !== '' && form.getFieldValue('email') !== null)
      && (form.getFieldValue('documentNumber') !== '' && form.getFieldValue('documentNumber') !== null)
    ) {
      return true;
    }
    return false;
  };

  const fetchApplicant = async () => {
    setLoading({ ...loading, fetch: true });
    const id = reservationForm.getFieldValue('user_id');
    const [response] = await getUser(id);

    form.setFieldsValue({
      'id': response.id,
      'active': response.active,
      'documentNumber': response.document_type === 'rut' ? format(response.document_number) : response.document_number,
      'documentType': response.document_type,
      'email': response.email,
      'userProfileId': response.user_profile_id,
      'firstName': response.first_name,
      'lastName': response.last_name,
      'phone': PhoneInput.formatPhone(response.phone, countryCode),
    })
    setLoading({ ...loading, fetch: false });
  };

  useEffect(() => {
    form.resetFields();
    if (applicantModal.type === 'edit') {
      fetchApplicant();
    } else {
      form.setFieldsValue({ 'documentType': countryCode === 'PE' ? 'dni' : 'rut' });
    }
  }, [applicantModal.visible]);


  const submit = () => {
    if (validateFormFields()) {
      form
        .validateFields()
        .then(() => {
          setLoading({ ...loading, submit: true });
          const values = form.getFieldsValue();
          let responsePromise;
          const params = {
            userToken: getCookie('user'),
            document_number: values.documentType === 'rut' ? format(values.documentNumber, { dots: false }) : values.documentNumber,
            document_type: values.documentType,
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            phone: values.phone.includes('+') ? values.phone : `+${values.phone}`,
          };

          if (values.id) {
            params['userProfileId'] = values.userProfileId;
            responsePromise = updateUser(values.id, params);
          } else {
            responsePromise = createUser(params);
          }

          responsePromise
            .then((response) => {
              const user = response.user_profile;

              addApplicant({
                fullname: `${user.first_name} ${user.last_name}`,
                id: response.id,
              });

              reservationForm.setFieldsValue({
                user_id: response.id,
              });

              message.success({
                content: `Solicitante ${applicantModal.type === 'edit' ? 'actualizado' : 'creado'} exitosamente`,
                style: {
                  marginTop: '40vh',
                },
              });
            })
            .catch((err) => {
              console.error('Error interno:', err);

              const errorMessage = handlers.isJSON(err) ? JSON.parse(err) : err;
              message.error({
                content: `Error interno: ${errorMessage && errorMessage.message}`,
                style: {
                  marginTop: "35vh",
                },
              });
            })
            .finally(() => {
              setLoading({ ...loading, submit: false });
              form.resetFields();
              setApplicantModal({ ...applicantModal, visible: false });
            });
        })
    } else {
      message.error({
        content: 'Error en los campos del formulario',
        style: {
          marginTop: '40vh',
        },
      });
    }
  };

  return (
    <Modal
      className="creation-modal"
      open={applicantModal && applicantModal.visible}
      footer={false}
      closable
      onCancel={closeModal}
    >
      <Spin className='cmt-spin' spinning={loading.fetch}>
        <Form form={form} layout="vertical">
          <Row>
            <Col lg={24} xs={24}>
              <h1 className='text-center mb-20'>
                {applicantModal && applicantModal.type === 'create' ? 'Nuevo solicitante' : 'Editar solicitante'}
              </h1>
            </Col>
            <Col lg={24} xs={24}>
              <Row gutter={12}>
                <Col lg={12} xs={24}>
                  <Form.Item name="id" hidden>
                    <Input />
                  </Form.Item>
                  <Form.Item name="userProfileId" hidden>
                    <Input />
                  </Form.Item>
                  <Row className='documentType-wrapper'>
                    <Col lg={24} xs={24}>
                      <p>{t('reservations.applicantModal.documentNumberLabel')}</p>
                    </Col>
                    <Col lg={24} xs={24} className='creation-modal aplicant document-select-wrapper'>
                      <DocumentCard
                        countryCode={countryCode}
                        setDocumentType={setDocumentType}
                        form={form}
                        type='person'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name="firstName"
                    label={t('reservations.applicantModal.firstNameLabel')}
                    rules={[{ required: true, message: 'Este campo es requerido' }]}
                  >
                    <Input className="cmt-input" placeholder='Ingrese nombres' />
                  </Form.Item>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name="lastName"
                    label={t('reservations.applicantModal.lastNameLabel')}
                    rules={[{ required: true, message: 'Este campo es requerido' }]}
                  >
                    <Input className="cmt-input" placeholder='Ingrese apellidos' />
                  </Form.Item>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    name="email"
                    label={t('reservations.applicantModal.emailLabel')}
                    rules={[
                      { required: true, message: 'Este campo es requerido' },
                      { type: 'email', message: 'El email es inválido' }
                    ]}
                  >
                    <Input className="cmt-input" type="email" id="emailTest" placeholder='Ingrese email' />
                  </Form.Item>
                </Col>
                <Col lg={12} xs={24}>
                  <PhoneInput.ReactPhone
                    countryCode={countryCode}
                    form={form}
                    labelText='Teléfono'
                  />
                </Col>
              </Row>
            </Col>
            <Col lg={24} xs={24} className="mt-20">
              <Row justify='center' gutter={[15, 15]}>
                <Col lg={10} xs={24}>
                  <Button
                    disabled={loading.submit}
                    className='cmt-button primary outline'
                    type='primary'
                    onClick={closeModal}
                  >
                    Cancelar
                  </Button>
                </Col>
                <Col lg={10} xs={24}>
                  <Button
                    loading={loading.submit}
                    disabled={loading.submit}
                    className='cmt-button primary'
                    type='primary'
                    onClick={submit}
                  >
                    {applicantModal && applicantModal.type === 'create' ? 'Crear solicitante' : 'Actualizar solicitante'}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  )
}

export default ApplicantModal;
